// extracted by mini-css-extract-plugin
export default {"root":"Header_root__817Kt","headerIcon":"Header_headerIcon__j8WrZ"};